import { tv } from 'tailwind-variants'

export const radioVariants = tv({
  slots: {
    root: [
      'group/radio',
      'relative inline-flex shrink-0 cursor-pointer items-center justify-center',
      'rounded-full border-2 border-solid',
      'appearance-none m-0 bg-transparent p-0',
      'transition-[border-color,box-shadow] duration-150',
      'outline-none',
      'data-[focus-visible]:outline data-[focus-visible]:outline-1 data-[focus-visible]:outline-offset-2 data-[focus-visible]:outline-primary-main',
      'data-[disabled]:cursor-not-allowed data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      'data-[unchecked]:border-text-action-active',
      'data-[checked]:border-text-action-active',
    ],
    indicator: ['block rounded-full pointer-events-none'],
    label: ['inline-flex cursor-pointer items-center gap-2'],
    labelText: ['text-sm text-text-primary'],
  },
  variants: {
    size: {
      small: {
        root: 'size-4',
        indicator: 'size-2',
      },
      medium: {
        root: 'size-5',
        indicator: 'size-2.5',
      },
      large: {
        root: 'size-6',
        indicator: 'size-3',
      },
    },
    color: {
      primary: {},
      default: {},
      secondary: {},
      error: {},
      warning: {},
      info: {},
      success: {},
    },
    labelPlacement: {
      end: { label: 'h-10' },
      start: { label: 'h-10 flex-row-reverse' },
      top: { label: 'flex-col-reverse' },
      bottom: { label: 'flex-col' },
    },
    disabled: {
      true: {
        label: 'pointer-events-none cursor-not-allowed',
        labelText: 'opacity-50',
      },
    },
  },
  compoundVariants: [
    {
      color: 'primary',
      className: {
        root: [
          'data-[checked]:border-primary-main',
          'hover:border-primary-main hover:shadow-glow-checkbox-primary',
          'data-[checked]:active:border-primary-dark',
        ],
        indicator: 'bg-primary-main',
      },
    },
    {
      color: 'default',
      className: {
        root: ['hover:border-text-secondary hover:shadow-glow-checkbox-default'],
        indicator: 'bg-text-secondary',
      },
    },
    {
      color: 'secondary',
      className: {
        root: ['hover:border-secondary-light', 'hover:shadow-glow-checkbox-secondary'],
        indicator: 'bg-secondary-light',
      },
    },
    {
      color: 'error',
      className: {
        root: ['hover:border-error-main', 'hover:shadow-glow-checkbox-error'],
        indicator: 'bg-error-main',
      },
    },
    {
      color: 'warning',
      className: {
        root: ['hover:border-warning-main', 'hover:shadow-glow-checkbox-warning'],
        indicator: 'bg-warning-main',
      },
    },
    {
      color: 'info',
      className: {
        root: ['hover:border-info-main', 'hover:shadow-glow-checkbox-info'],
        indicator: 'bg-info-main',
      },
    },
    {
      color: 'success',
      className: {
        root: ['hover:border-success-main', 'hover:shadow-glow-checkbox-success'],
        indicator: 'bg-success-main',
      },
    },
  ],
  defaultVariants: {
    size: 'medium',
    color: 'primary',
  },
})

export type RadioVariants = Parameters<typeof radioVariants>[0]
